import {ChangeDetectionStrategy, Component} from '@angular/core';


@Component({
    selector: 'app-other-reports',
    template: '<app-reports-view category="Other"></app-reports-view>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OtherReportsComponent {

    category = 'Other';

    constructor() {
    }

}
